import { Box, Typography } from '@mui/material';
import { formatters, ValueInput } from '@utils/formattersV2';

type BaseBarData = {
  label: string;
  fillColor?: string;
};

type RawMetricData = BaseBarData & {
  value: number;
};

type NormalizedBarRow = BaseBarData & {
  value: number;
  percentage: number;
};

type MetricBarCardProps = {
  title: string;
  lift?: ValueInput;
  rows: NormalizedBarRow[];
  testId?: string;
  valueFormatter?: (value: ValueInput) => string;
};

export const normalizeBarData = (data: RawMetricData[]): NormalizedBarRow[] => {
  const maxValue = Math.max(...data.map(d => d.value));
  return data.map(d => ({
    label: d.label,
    value: d.value,
    fillColor: d.fillColor,
    percentage: (d.value / maxValue) * 100,
  }));
};

export const MetricBarCard = ({
  title,
  lift,
  rows,
  testId,
  valueFormatter,
}: MetricBarCardProps) => {
  return (
    <Box data-testid={testId}>
      <Typography variant="body2" color="text.secondary">
        {title}
      </Typography>
      {lift ? (
        <Typography variant="h4" mb={1}>
          {formatters.percentage(lift, { decimals: 1 })}
        </Typography>
      ) : null}
      {rows.map(row => (
        <Box key={`${row.label}-${row.fillColor}-${row.value}`}>
          <Typography fontSize={13} color="text.secondary" mb={0.5}>
            {row.label}
          </Typography>
          <Box display="flex" alignItems="center">
            <Box
              sx={{
                height: 8,
                width: `${row.percentage}%`,
                backgroundColor: row.fillColor ?? '#1976D2',
                borderRadius: 5,
              }}
            />
            <Typography fontWeight="bold" fontSize={13} ml={1}>
              {valueFormatter ? valueFormatter(row.value) : row.value}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};
